import React from 'react';
import footerTemplate from '../shared/footerTemplate';
import '../shared/footerStyles.css';

const Footer = () => (
  <footer className="site-footer">
    <div className="site-footer__inner">
      <section className="site-footer__column" aria-labelledby="footer-about">
        <strong id="footer-about" className="site-footer__title">
          {footerTemplate.aboutTitle}
        </strong>
        <p className="site-footer__text">{footerTemplate.aboutText}</p>
      </section>

      <section className="site-footer__column" aria-labelledby="footer-social">
        <strong id="footer-social" className="site-footer__title">
          {footerTemplate.contactTitle}
        </strong>
        <p className="site-footer__text">
          Instagram:{' '}
          <a
            className="site-footer__link"
            href={footerTemplate.instagram.url}
            rel="noreferrer"
            target="_blank"
          >
            {footerTemplate.instagram.label}
          </a>
        </p>
        <p className="site-footer__text">
          Contact:{' '}
          <a className="site-footer__link" href={`mailto:${footerTemplate.email}`}>
            {footerTemplate.email}
          </a>
        </p>
      </section>

      <section className="site-footer__column" aria-labelledby="footer-disclaimer">
        <strong id="footer-disclaimer" className="site-footer__title">
          {footerTemplate.disclaimerTitle}
        </strong>
        <p className="site-footer__text">{footerTemplate.disclaimerText}</p>
      </section>
    </div>
  </footer>
);

export default Footer;
